import { Link } from "react-router-dom";
import {
  isLikeLoadingState,
  likeCountState,
  userBoardLikeState
} from "../../../../atoms/atom";
import { useRecoilValue } from "recoil";
import "./PageMobileBtn.scoped.scss";
import { useTranslation, withTranslation } from "react-i18next";
import { redirectURL } from "../../../../utils/CommonFunc";
import { ILoungeInfo } from "../../../../api/api";
import { isLauncherState } from "../../../../atoms/userInfoAtom";

interface IProps {
  data: ILoungeInfo;
  getLikeBoard: () => void;
}

function PageMobileBtn(props: IProps) {
  const { t } = useTranslation();
  const { data, getLikeBoard } = props;
  const userBoardLike = useRecoilValue(userBoardLikeState);
  const likeCount = useRecoilValue(likeCountState);
  const isLikeLoading = useRecoilValue(isLikeLoadingState);
  const isLauncher = useRecoilValue(isLauncherState);

  const webUrl =
    data?.data.pre_regist_url === null ? undefined : data?.data.pre_regist_url;

  return (
    <div className="pageMobileActivity">
      <ul>
        {data.data.web_url === null || data.data.web_url === "" ? null : (
          <li>
            <Link
              to="#"
              onClick={(e) =>
                redirectURL(data?.data.web_url, "_self", isLauncher)
              }
              title={t("homepage")}
            >
              <span className="icon home" />
            </Link>
          </li>
        )}
        {data.data.pre_regist_url === null ||
        data.data.pre_regist_url === "" ? null : (
          <li>
            <Link
              to="#"
              onClick={(e) => redirectURL(webUrl || "", "_self", isLauncher)}
              title={t("share")}
            >
              <span className="icon gamepad" />
            </Link>
          </li>
        )}
        <li onClick={getLikeBoard}>
          <Link to="#" title={t("like")}>
            <span className={`icon ${userBoardLike ? "on" : "white"} like`} />
            {!isLikeLoading ? (
              <span className="txt">{likeCount.toLocaleString()}</span>
            ) : (
              <span className="fa fa-solid fa-circle-notch fa-spin" />
            )}
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default withTranslation()(PageMobileBtn);
